module.exports = __webpack_public_path__ + "img/coverBanner-responsive.61f33e0d.jpg";